import React,{useEffect,useState} from 'react'
import { BrowserRouter as Router,Routes, Route,} from 'react-router-dom';
import HomePage from './Pages/HomePage';
import DetailPage from './Pages/DetailPage';
import AboutUs from './Pages/AboutUs';
import VoiceBasedMultilingualForm from './Components/VoiceBasedMultilingualForm';
import VoiceTextToTextImageToTextTranslation from './Components/VoiceTextToTextImageToTextTranslation';
import VoiceToTextAndSpeechToSpeech from './Components/VoiceToTextAndSpeechToSpeech';
import AiSummary from './Components/AiSummary';
import AiVideoGenerator from './Components/AiVideoGenerator';
import Branding from './Components/Branding';
import DictationTool from './Components/DictationTool';
import FaceCutout from './Components/FaceCutout';
import GovtofIndiaSchemesAndInitiatives from './Components/GovtofIndiaSchemesAndInitiatives';
import ImageBackgroundRemover from './Components/ImageBackgroundRemover';
import LegalGlossary from './Components/LegalGlossary';
import MannKiBat from './Components/MannKiBat';
import MeetingCapture from './Components/MeetingCapture';
import OnlineDocumentTranslationTool from './Components/OnlineDocumentTranslationTool';
import VideoTranslation from './Components/VideoTranslation';
import PassportPhotoMaker from './Components/PassportPhotoMaker';
import RemoveUnwantedObjects from './Components/RemoveUnwantedObjects';
import VideoBackgroundRemover from './Components/VideoBackgroundRemover';
import VideowithVoice from './Components/VideowithVoice';
import TexttoVideo from './Components/TexttoVideo';
import VirtualKeyboard from './Components/VirtualKeyboard';
import ScreenRecording from './Components/ScreenRecording';
import VideoRecording from './Components/VideoRecording';
import MultiCameraRecording from './Components/MultiCameraRecording';
import PhoneasWebcam from './Components/PhoneasWebcam';
import Teleprompter from './Components/Teleprompter';
import RemoveCameraBackground from './Components/RemoveCameraBackground';
import ThreeDAudio from './Components/ThreeDAudio';
import AutoPartner from './Components/AutoPartner';
import BassBooster from './Components/BassBooster';
import Equalizer from './Components/Equalizer';
import NoiseReducer from './Components/NoiseReducer';
import PitchShifter from './Components/PitchShifter';
import Reverb from './Components/Reverb';
import ReverseAudio from './Components/ReverseAudio';
import StereoPanner from './Components/StereoPanner';
import TempoChanger from './Components/TempoChanger';
import TrimmerCutter from './Components/TrimmerCutter';
import VocalRemover from './Components/VocalRemover';
import VolumeChanger from './Components/VolumeChanger';
import ImageEditor from './Components/Editor/ImageEditor';
import TirmOfUse from './Components/TirmOfUse';
import PrivacyPolicy from './Components/PrivacyPolicy';
import OutletRoute from './Components/OutletRoute';
import AIVideoAnalyzer from './Pages/AIVideoAnalyzer';
import UploadFile from './Components/UploadFile';
import AiDiscription from './Components/VideoCamera/AiDiscription';
import VideoForm from './Pages/VideoForm';
import LoginPage from './Pages/loginPage.jsx';
import VideoDetailPage from './Components/VideoCamera/VideoDetailPage';
import ValidatorView from './Components/VideoCamera/validatorView.jsx';

function RoutingPage() {
  const [isLogin, setIsLogin] = useState(false);
  useEffect(()=>{
    let token = localStorage.getItem('token')
    if(token){
      setIsLogin(true)
    }
  },[])
  return (
    <>
    <Router>      
      {/* <Header/> */}
        <Routes>
            {/* Pages */}
            <Route path='/face-analyser/' element={<OutletRoute isLogin={isLogin} setIsLogin={setIsLogin}/>}>
            <Route index element={<VideoForm/>}/>
            <Route path='/face-analyser/detailPage' element={<DetailPage/>}></Route>
            <Route path='/face-analyser/aboutUs' element={<AboutUs/>}></Route>
            <Route path='/face-analyser/video/form' element={<VideoForm/>}></Route>
            <Route path='/face-analyser/login' element={<LoginPage setIsLogin={setIsLogin}/>}></Route>
            {/* Translation */}
            <Route path='/face-analyser/onlineDocumentTranslationTool' element={<OnlineDocumentTranslationTool/>}></Route>
            <Route path='/face-analyser/govtofIndiaSchemesAndInitiatives' element={<GovtofIndiaSchemesAndInitiatives/>}></Route>
            <Route path='/face-analyser/mannKiBat' element={<MannKiBat/>}></Route>
            <Route path='/face-analyser/voiceBasedMultilingualForm' element={<VoiceBasedMultilingualForm/>}></Route>
            <Route path='/face-analyser/dictationTool' element={<DictationTool/>}></Route>  
            <Route path='/face-analyser/legalGlossary' element={<LegalGlossary/>}></Route> 
            <Route path='/face-analyser/videoTranslation' element={<VideoTranslation/>}></Route>
            {/* Voice */}
            <Route path='/face-analyser/VoiceToTextAndSpeechToSpeech' element={<VoiceToTextAndSpeechToSpeech/>}></Route>
            <Route path='/face-analyser/VoiceTextToTextImageToTextTranslation' element={<VoiceTextToTextImageToTextTranslation/>}></Route>
            <Route path='/face-analyser/ThreeDAudio' element={<ThreeDAudio/>}></Route>
            <Route path='/face-analyser/Autopartner' element={<AutoPartner/>}></Route>
            <Route path='/face-analyser/BassBooster' element={<BassBooster/>}></Route>
            <Route path='/face-analyser/Equalizer' element={<Equalizer/>}></Route>
            <Route path='/face-analyser/NoiseReducer' element={<NoiseReducer/>}></Route>  
            <Route path='/face-analyser/PitchShifter' element={<PitchShifter/>}></Route>  
            <Route path='/face-analyser/Reverb' element={<Reverb/>}></Route>  
            <Route path='/face-analyser/reverseAudio' element={<ReverseAudio/>}></Route>  
            <Route path='/face-analyser/stereoPanner' element={<StereoPanner/>}></Route>  
            <Route path='/face-analyser/tempoChanger' element={<TempoChanger/>}></Route>  
            <Route path='/face-analyser/trimmerCutter' element={<TrimmerCutter/>}></Route>  
            <Route path='/face-analyser/vocalRemover' element={<VocalRemover/>}></Route>  
            <Route path='/face-analyser/volumeChanger' element={<VolumeChanger/>}></Route>  
           {/* Video */}
           <Route path='/face-analyser/videoBackgroundRemover' element={<VideoBackgroundRemover/>}></Route>
           <Route path='/face-analyser/videowithVoice' element={<VideowithVoice/>}></Route>
           <Route path='/face-analyser/texttoVideo' element={<TexttoVideo/>}></Route>
           <Route path='/face-analyser/aiSummary' element={<AiSummary/>}></Route>
           <Route path='/face-analyser/aiVideoGenerator' element={<AiVideoGenerator/>}></Route>
           <Route path='/face-analyser/branding' element={<Branding/>}></Route>
           <Route path='/face-analyser/AIVideoAnalyzer' element={<AIVideoAnalyzer/>}></Route>
           <Route path='/face-analyser/UploadFile' element={<UploadFile/>}></Route>
           <Route path='/face-analyser/AiDiscription' element={<AiDiscription/>}></Route>
           <Route path='/face-analyser/VideoDetailPage' element={<VideoDetailPage/>}></Route>
           <Route path='/face-analyser/validatorView' element={<ValidatorView/>}></Route>
         
           {/* Images */}
           <Route path='/face-analyser/passportPhotoMaker' element={<PassportPhotoMaker/>}></Route>
           <Route path='/face-analyser/faceCutout' element={<FaceCutout/>}></Route>
           <Route path='/face-analyser/removeUnwantedObjects' element={<RemoveUnwantedObjects/>}></Route>
           <Route path='/face-analyser/imageBackgroundRemover' element={<ImageBackgroundRemover/>}></Route>
           
          {/* Meeting*/}
            <Route path='/face-analyser/virtualKeyboard' element={<VirtualKeyboard/>}></Route>
            <Route path='/face-analyser/screenRecording' element={<ScreenRecording/>}></Route>
            <Route path='/face-analyser/videoRecording' element={<VideoRecording/>}></Route>
            <Route path='/face-analyser/meetingCapture' element={<MeetingCapture/>}></Route>
            <Route path='/face-analyser/multiCameraRecording' element={<MultiCameraRecording/>}></Route>
            <Route path='/face-analyser/phoneasWebcam' element={<PhoneasWebcam/>}></Route>
            <Route path='/face-analyser/teleprompter' element={<Teleprompter/>}></Route>
            <Route path='/face-analyser/removeCameraBackground' element={<RemoveCameraBackground/>}></Route>
            <Route path='/face-analyser/tirmOfUse' element={<TirmOfUse/>}></Route>
            <Route path='/face-analyser/privacyPolicy' element={<PrivacyPolicy/>}></Route>
            </Route>
        </Routes>
        
      {/* <Footer/> */}
      <Routes>
        <Route path='/face-analyser/Editor/ImageEditor' element={<ImageEditor/>}></Route>
      </Routes>
    </Router>
    </>
  )
}

export default RoutingPage
